import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';
import { useSearch } from '@tanstack/react-router';

import { Tooltip } from 'components/common/Tooltip';
import { IconAudio, IconAudioMute } from 'components/icons';
import { useAspenLogger } from 'hooks/useAspenLogger';

interface SoundProps {
  soundEnabled: boolean;
  toggleSound: () => void;
}

export const Sound = ({ soundEnabled, toggleSound }: SoundProps) => {
  const { eventId } = useSearch({ from: '/events' });
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title={soundEnabled ? 'Mute' : 'Unmute'} placement="top">
      <IconButton
        aria-label="sound"
        data-testid="button-sound"
        onClick={() => {
          if (eventId) {
            logAspenEvent({
              log_id: 'iot.web.event.interaction',
              payload: {
                event_id: eventId,
                interaction: 'sound',
              },
            });
          }

          toggleSound();
        }}
        sx={{
          '&.MuiIconButton-root': {
            padding: '0', // Override RDS padding
          },
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {soundEnabled ? (
          <IconAudio sx={{ color: colors.purple[500] }} />
        ) : (
          <IconAudioMute sx={{ color: colors.grey[400] }} />
        )}
      </IconButton>
    </Tooltip>
  );
};
